"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.FileVersionOneError = void 0;
var errors_1 = require("./errors");
var types_1 = require("./types");
var FileVersionOneError = /** @class */ (function (_super) {
    __extends(FileVersionOneError, _super);
    function FileVersionOneError() {
        var _this = _super.call(this, 'File version 1') || this;
        Object.setPrototypeOf(_this, FileVersionOneError.prototype);
        return _this;
    }
    return FileVersionOneError;
}(Error));
exports.FileVersionOneError = FileVersionOneError;
function downloadFile(fileId, bucketId, mnemonic, network, crypto, toBinaryData, downloadFile, decryptFile, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var iv, indexHex, key, mnemonicIsValid, _a, index, shards, version, size, downloadables, err_1, context;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    if (!(opts === null || opts === void 0 ? void 0 : opts.token)) {
                        mnemonicIsValid = crypto.validateMnemonic(mnemonic);
                        if (!mnemonicIsValid) {
                            throw new errors_1.DownloadInvalidMnemonicError();
                        }
                    }
                    return [4 /*yield*/, network.getDownloadLinks(bucketId, fileId, opts === null || opts === void 0 ? void 0 : opts.token)];
                case 1:
                    _a = _b.sent(), index = _a.index, shards = _a.shards, version = _a.version, size = _a.size;
                    if (!version || version === 1) {
                        throw new FileVersionOneError();
                    }
                    iv = toBinaryData(index, types_1.BinaryDataEncoding.HEX).slice(0, 16);
                    return [4 /*yield*/, crypto.generateFileKey(mnemonic, bucketId, toBinaryData(index, types_1.BinaryDataEncoding.HEX))];
                case 2:
                    key = _b.sent();
                    downloadables = shards.sort(function (sA, sB) { return sA.index - sB.index; });
                    return [4 /*yield*/, downloadFile(downloadables, size)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, decryptFile(crypto.algorithm.type, key, iv, size)];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _b.sent();
                    context = (0, errors_1.getNetworkErrorContext)({
                        bucketId: bucketId,
                        fileId: fileId,
                        user: network.credentials.username,
                        pass: network.credentials.password,
                        token: (opts === null || opts === void 0 ? void 0 : opts.token) || 'none',
                        crypto: {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            index: indexHex ? indexHex.toString('hex') : 'none',
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            iv: iv ? iv.toString('hex') : 'none',
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            key: key ? key.toString('hex') : 'none',
                            mnemonic: mnemonic
                        }
                    }, err_1);
                    err_1.context = context;
                    throw err_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.downloadFile = downloadFile;
